import { put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setRtsRespRateOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptions } from '../../../common/common.types'

export function* getRtsRespRateOptions() {
  try {
    const entity: IOptions = [
      { id: 0, name: '0' },
      { id: 1, name: '1-5' },
      { id: 2, name: '6-9' },
      { id: 3, name: '> 29' },
      { id: 4, name: '10-29' },
    ]
    yield put(setRtsRespRateOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRtsRespRateOptions() error: ${e}`))
  }
}
export function* getRtsRespRateOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRtsRespRateOptions)
}
